<template>
  <router-link
    v-if="route.routeType === 'internal'"
    :to="route.link"
    class="flex h-full items-center justify-center px-10 font-semibold text-white hover:bg-emo-mid-grey"
    :class="{
      '!bg-emo-dark-grey': isActive,
    }"
  >
    {{ route.title }}
  </router-link>

  <a
    v-else-if="route.routeType === 'external'"
    :href="route.link"
    target="_blank"
    class="flex h-full items-center justify-center px-10 font-semibold text-white hover:bg-emo-mid-grey"
    :class="{
      '!bg-emo-dark-grey': isActive,
    }"
  >
    {{ route.title }}
  </a>
</template>

<script setup lang="ts">
import { RouteConfig } from '@/common';
import { RouterLink } from 'vue-router';
defineProps<{
  route: RouteConfig;
  isActive: boolean;
}>();
</script>
